import script from "./VoicePaper.vue?vue&type=script&setup=true&lang=js"
export * from "./VoicePaper.vue?vue&type=script&setup=true&lang=js"

import "./VoicePaper.vue?vue&type=style&index=0&id=5eddb6f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eddb6f2"]])

export default __exports__